/* Shared event emitter for the popup, cart and landing-page funnels.

   Shopify already measures view-product, add-to-cart, initiate-checkout and
   purchase. What it does NOT measure is everything before and beside those:
   a CTA click, a form started and sent, which landing variant a visitor saw.
   Without those steps the top of the funnel can't be drawn.

   A DONDE VAN.  Se emiten a los tres destinos que existen de verdad en esta
   tienda, y cada uno se salta solo si no esta:

     · Shopify.analytics.publish  — el canal de eventos propios. Cualquier Web
       Pixel puede suscribirse, incluidos los de GA4 o Meta el dia que se
       conecten. Es el destino que no caduca.
     · Klaviyo (_learnq)          — para segmentos y flujos.
     · Microsoft Clarity          — etiqueta la sesion, que es lo que hace falta
       para ver DONDE se cae la gente, no solo cuanta.
     · El portal                  — /api/storefront/events. Es el unico destino
       que puede cruzar el paso con el CODIGO DE CAMPANA y por tanto con la
       organizacion: Shopify ve el pedido, Klaviyo ve el perfil, y ninguno de
       los dos sabe de quien era el enlace. Se apaga dejando vacio el ajuste
       «Storefront analytics endpoint» del tema.

   Se emite a todos a la vez a proposito: si manana se quita uno, los otros
   siguen midiendo, y nadie tiene que acordarse de volver a instrumentar.

   NO se envia informacion personal. El codigo de referido no lo es —va en la
   URL que la propia organizacion reparte— y es justo lo que permite separar los
   dos embudos.

   TAMBIEN LOS POPUPS.  Se expone `window.LBTrack` para que el popup de cupon y
   el de suscripcion emitan por aqui en vez de montarse su propio reparto. Eso
   es lo que devuelve la analitica que se pierde al no usar el formulario
   alojado de Klaviyo — y de paso da un embudo que aquel no daba: cuantos pasan
   del correo al SMS, y cuantos aceptan la suscripcion tras anadir al carrito.

   OJO CON LAS VISTAS EN KLAVIYO.  Klaviyo solo cuelga un evento de un perfil
   conocido: la vista de un popup que nadie llega a rellenar no aparece alli.
   El recuento honesto de vistas esta en Shopify.analytics y en Clarity, que si
   miden anonimos.

   LO QUE ESTE FICHERO NO PUEDE MEDIR, y hay que sacar del portal: llamada
   agendada, partner aprobado y campana lanzada. Esos tres pasos ocurren fuera
   de la tienda. */
(function () {
  'use strict';

  function ref() {
    var u = '';
    try { u = (new URLSearchParams(location.search).get('ref') || '').trim(); } catch (e) {}
    if (!u) {
      var m = document.cookie.match('(^|;)\\s*lp_ref\\s*=\\s*([^;]+)');
      u = m ? decodeURIComponent(m.pop()) : '';
    }
    return u.toUpperCase().replace(/[^A-Z0-9]/g, '');
  }

  /* Un evento no se manda dos veces en la misma pagina. Sin esto, un formulario
     con varios campos emitiria "solicitud iniciada" en cada pulsacion. */
  var yaEmitido = {};

  /* Identificador de PESTANA, no de persona: se genera aqui, muere al cerrarla y
     no significa nada en ningun otro sitio. Sirve para saber que dos pasos son
     del mismo recorrido, que es lo unico que un embudo necesita. */
  function sesion() {
    try {
      var k = sessionStorage.getItem('lb_sid');
      if (!k) {
        k = (Date.now().toString(36) + Math.random().toString(36).slice(2, 10));
        sessionStorage.setItem('lb_sid', k);
      }
      return k;
    } catch (e) { return ''; }
  }

  /* El quinto destino: el portal.

     Va por `sendBeacon` para que un paso disparado al salir de la pagina no se
     pierda — un `fetch` normal se cancela con la navegacion, y "checkout
     empezado" es justo el paso que ocurre al irse.

     Con `text/plain` a proposito: `sendBeacon` NO puede hacer preflight, asi que
     mandarlo como `application/json` haria que cada baliza fallara en silencio.
     El endpoint lee el cuerpo crudo y lo parsea el mismo. */
  function alPortal(nombre, carga) {
    var url = window.LB_ANALYTICS_ENDPOINT;
    if (!url) return;
    try {
      var cuerpo = JSON.stringify({
        events: [{
          name: nombre,
          path: carga.path,
          ref: carga.ref || '',
          value: typeof carga.value === 'number' ? carga.value : undefined,
          session: sesion(),
          props: carga
        }]
      });
      if (navigator.sendBeacon) {
        navigator.sendBeacon(url, new Blob([cuerpo], { type: 'text/plain;charset=UTF-8' }));
      } else {
        fetch(url, { method: 'POST', body: cuerpo, keepalive: true, mode: 'cors' });
      }
    } catch (e) {}
  }

  function emitir(nombre, datos, opciones) {
    /* `repetir` para lo que de verdad pasa mas de una vez en la misma pagina:
       abrir un popup dos veces son dos vistas, no una. */
    if (yaEmitido[nombre] && !(opciones && opciones.repetir)) return;
    yaEmitido[nombre] = true;

    var carga = datos || {};
    var r = ref();
    if (r) carga.ref = r;
    carga.path = location.pathname;

    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish(nombre, carga);
      }
    } catch (e) {}
    try {
      window._learnq = window._learnq || [];
      window._learnq.push(['track', nombre, carga]);
    } catch (e) {}
    try {
      if (typeof window.clarity === 'function') window.clarity('event', nombre);
    } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: nombre }, carga));
    } catch (e) {}
    alPortal(nombre, carga);
  }

  function iniciar() {
    var cuerpo = document.body;
    /* El handle viene de Liquid (data-page-handle), no de una clase: el <body>
       solo lleva `template-page`, sin sufijo, asi que deducirlo del marcado no
       funcionaba y ningun evento de organizacion llegaba a emitirse. */
    var handle = cuerpo.getAttribute('data-page-handle') || '';
    var esOrg = /^(youth-sports|nonprofit|fundraising|partner-with-us)$/.test(handle);
    var esSolicitud = /^lol-(youth-sports|nonprofit)$/.test(handle);
    var esCampana = !!document.querySelector('[data-lol-campaign]');

    /* ── Embudo de la organizacion ── */
    if (esOrg) {
      emitir('lb_org_page_view', { page: handle });
      document.addEventListener('click', function (e) {
        var a = e.target.closest('a.fr-btn, a.np-cta');
        if (!a) return;
        var destino = a.getAttribute('href') || '';
        /* la llamada es la accion secundaria: se distingue por destino, no por
           el texto del boton, que el comercio puede reescribir cuando quiera */
        var esLlamada = /bookings|calendly|simpletalk/.test(destino);
        emitir(esLlamada ? 'lb_org_call_click' : 'lb_org_cta_click',
               { page: handle, href: destino });
      }, true);
    }

    if (esSolicitud) {
      emitir('lb_application_view', { application: handle });
      var form = document.querySelector('form');
      if (form) {
        /* "iniciada" = la primera vez que alguien escribe algo, no que la
           pagina cargue: abrir una solicitud y abandonarla sin tocarla no es
           haberla empezado */
        form.addEventListener('input', function () {
          emitir('lb_application_start', { application: handle });
        }, { once: true, capture: true });
        form.addEventListener('submit', function () {
          emitir('lb_application_submit', { application: handle });
        }, true);
      }
    }

    /* ── Embudo del simpatizante ── */
    if (esCampana) {
      var r = ref();
      emitir(r ? 'lb_campaign_view' : 'lb_campaign_view_noref', {});
      var raiz = document.querySelector('[data-lol-campaign]');
      raiz.addEventListener('click', function (e) {
        var o = e.target.closest('[data-lolc-opt]');
        if (o) {
          /* aqui si conviene repetir: cambiar de opcion es la senal */
          yaEmitido.lb_campaign_option = false;
          emitir('lb_campaign_option', {
            variant: o.getAttribute('data-vid'),
            price: o.getAttribute('data-price'),
          });
          return;
        }
        if (e.target.closest('[data-lolc-cta]')) {
          emitir('lb_campaign_add', {});
        }
      }, true);
    }

    /* Un pedido que llega con codigo es un pedido de campana: marcarlo en el
       inicio del checkout permite separar los dos embudos aguas abajo, donde
       los pixeles de Shopify ya no distinguen de donde venia la visita. */
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href*="/checkout"], button[name="checkout"]');
      if (a && ref()) emitir('lb_campaign_checkout_start', {});
    }, true);
  }

  /* Se abre al resto del tema para que los popups no tengan que reimplementar
     el reparto a cuatro destinos —y para que el dia que se anada o se quite uno,
     se toque aqui y ya. */
  window.LBTrack = {
    emit: emitir,
    /* Klaviyo no cuelga eventos de un navegador anonimo: los guarda y los pega
       cuando sabe quien es. El formulario alojado de Klaviyo hace este identify
       solo; el nuestro, al suscribir por fetch, no lo hacia — y sin el, ese
       visitante no entra en carrito abandonado ni en navegacion abandonada
       hasta que pida algo o pinche un correo. */
    identify: function (perfil) {
      if (!perfil || (!perfil.$email && !perfil.$phone_number)) return;
      try { if (window.klaviyo && window.klaviyo.identify) { window.klaviyo.identify(perfil); return; } } catch (e) {}
      try { window._learnq = window._learnq || []; window._learnq.push(['identify', perfil]); } catch (e) {}
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
